import Data from "../types/Data";

export default function isEmpty(data: Data) {
  return (
    data.personIds.length === 0 &&
    data.groupIds.length === 0 &&
    data.receiptIds.length === 0
  );
}
